import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'psnb-mobile-power-supplypage401',
  templateUrl: './power-supplypage401.component.html',
  styleUrls: ['./power-supplypage401.component.scss']
})
export class PowerSupplypage401Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
